import { Link } from "react-router-dom";
import { toast } from "sonner";
import { CopyPlus, GitCompare, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";
import { fmtNum } from "@/lib/studio";

export const DraftBar = ({ story, draftId, onSelect, onCreated, compareLink }) => {
  const isOwner = story.role === "owner";
  const viewingOld = draftId !== story.current_draft_id;
  const newDraft = async () => {
    try {
      const d = (await api.post(`/stories/${story.id}/drafts`, {})).data;
      toast.success(`${d.name} started. Earlier drafts are now read-only.`);
      onCreated(d.id);
    } catch (e) {
      toast.error(errMsg(e), e.response?.status === 402 ? { action: { label: "See plans", onClick: () => window.location.assign("/pricing") } } : undefined);
    }
  };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="draft-bar">
      <Select value={draftId} onValueChange={onSelect}>
        <SelectTrigger className="h-9 w-64" data-testid="draft-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          {story.drafts.map((d) => (
            <SelectItem key={d.id} value={d.id} data-testid={`draft-option-${d.number}`}>
              <span className="flex items-center gap-1.5">{d.locked && <Lock className="h-3 w-3" />}{d.name} · {fmtNum(d.words)} words</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {isOwner && <Button size="sm" variant="outline" onClick={newDraft} data-testid="new-draft-button"><CopyPlus className="mr-1 h-4 w-4" />{viewingOld ? "New draft from latest" : "New draft"}</Button>}
      {isOwner && story.drafts.length > 1 && <Button size="sm" variant="ghost" asChild><Link to={compareLink} data-testid="compare-drafts-link"><GitCompare className="mr-1 h-4 w-4" />Compare drafts</Link></Button>}
    </div>
  );
};
